import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { makeStyles, TextField, Typography } from '@material-ui/core';

import Style from './Style';
import Buttons from '../Buttons';
import { handleNumbers } from '../../../Utils/helper';
import VehicleInfo from '../VehicleInfo';

const useStyles = makeStyles(() => Style());

export default function CustomVehicle({ setToggle }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [vehicle, setVehicle] = useState();
  const [errors, setErrors] = useState();

  const selectedVehicle = useSelector(
    (state) =>
      state.customerVehicleSearch?.selectedCustomerAndVehicle?.vehicle || '',
  );

  const createVehicleLoading = useSelector(
    (state) => state.vehicle?.createVehicleLoading || false,
  );

  const generateROLoading = useSelector(
    (state) => state?.ro?.generateROLoading || false,
  );

  const pathname = history.location?.pathname || '';
  const {
    vehicleMake = '',
    vehicleModel = '',
    modelYear = '',
    displacement = '',
    licensePlate = '',
    vin = '',
    mcNumber = '',
    unitNumber = '',
  } = vehicle || '';

  const clearVehicleInfoOnHeader = (payload = '') => {
    if (
      !(
        selectedVehicle?.id &&
        (pathname.includes('/estimator') ||
          pathname.includes('/new-repairorder'))
      )
    ) {
      dispatch({
        type: 'SET_VEHICLE_INFO_ON_HEADER',
        payload,
      });
    }
  };

  useEffect(() => {
    if (modelYear || vehicleMake || vehicleModel) {
      clearVehicleInfoOnHeader(
        modelYear + ' ' + vehicleMake + ' ' + vehicleModel,
      );
    }
  }, [modelYear, vehicleMake, vehicleModel]);

  const handleChangeVehicle = (e, type) => {
    const { name } = e.target;
    let { value = '' } = e.target;
    value = value.trim();

    if (type === 'number') {
      if (isNaN(value) || +value > 5000) return;
      value = handleNumbers(value, 5000);
    }

    setVehicle({
      ...vehicle,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: false,
    });
  };

  // handle validations
  const checkValidation = () => {
    let errorObj = {};

    let isValid = true;

    // vehicle search case

    const vehicleErrs = {};
    let check = false;

    if (!vehicleMake || !vehicleModel || !modelYear || !displacement) {
      if (vehicleMake?.length > 300 || !vehicleMake) {
        vehicleErrs.vehicleMake = true;
        check = true;
      }

      if (vehicleModel?.length > 300 || !vehicleModel) {
        vehicleErrs.vehicleModel = true;
        check = true;
      }

      if (!modelYear) {
        vehicleErrs.modelYear = true;
        check = true;
      }

      if (+displacement > 5000) {
        vehicleErrs.displacement = true;
        check = true;
      }

      if (licensePlate?.length > 15) {
        vehicleErrs.licensePlate = true;
        check = true;
      }

      if (vin?.length > 17) {
        vehicleErrs.vin = true;
        check = true;
      }
    }

    if (check) {
      errorObj = {
        ...errorObj,
        ...vehicleErrs,
      };
      isValid = false;
    }

    setErrors({
      ...errors,
      ...errorObj,
    });

    return isValid;
  };

  const vehicleDetails = () => {
    if (checkValidation()) {
      return vehicle;
    }
  };

  const clearVehicleSelectStates = () => {
    setVehicle();

    clearVehicleInfoOnHeader();
  };

  const displayName = modelYear + ' ' + vehicleMake + ' ' + vehicleModel;

  return (
    <div>
      <VehicleInfo
        vehicleInfo={displayName?.trim() || ''}
        onClear={clearVehicleSelectStates}
        disabled={createVehicleLoading || generateROLoading}
      />
      <div className={clsx(classes.fields__main, 'w-100')}>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Vehicle Make*</Typography>
            <TextField
              type='text'
              name='vehicleMake'
              value={vehicleMake}
              placeholder='Enter Vehicle Make*'
              onChange={handleChangeVehicle}
              error={errors?.vehicleMake || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.vehicleMake && classes.is__error__border,
              )}
            />
          </div>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Vehicle Model*</Typography>
            <TextField
              type='text'
              name='vehicleModel'
              placeholder='Enter Vehicle Model*'
              value={vehicleModel}
              onChange={handleChangeVehicle}
              error={errors?.vehicleModel || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.vehicleModel && classes.is__error__border,
              )}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Model Year*</Typography>
            <TextField
              type='text'
              name='modelYear'
              placeholder='Enter Model Year*'
              value={modelYear}
              onChange={(e) => {
                if (e.target.value <= new Date().getFullYear()) {
                  handleChangeVehicle(e, 'number');
                }
              }}
              error={errors?.modelYear || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.modelYear && classes.is__error__border,
              )}
            />
          </div>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>License Plate*</Typography>
            <TextField
              type='text'
              name='licensePlate'
              placeholder='Enter License Plate'
              onChange={(e) => {
                const value = e.target.value?.toString() || '';

                if (/^[a-zA-Z0-9]*$/.test(value) && value.length < 16) {
                  handleChangeVehicle({
                    target: { value, name: 'licensePlate' },
                  });
                }
              }}
              value={licensePlate || ''}
              error={errors?.licensePlate || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.licensePlate && classes.is__error__border,
              )}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Engine Size</Typography>
            <TextField
              type='text'
              name='displacement'
              placeholder='Enter Engine Size'
              value={displacement}
              onChange={(e) => handleChangeVehicle(e, 'number')}
              error={errors?.displacement || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.displacement && classes.is__error__border,
              )}
            />
          </div>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>VIN</Typography>
            <TextField
              type='text'
              name='vin'
              placeholder='Enter VIN'
              onChange={handleChangeVehicle}
              value={vin}
              error={errors?.vin || false}
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.vin && classes.is__error__border,
              )}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>MC Number</Typography>
            <TextField
              type='text'
              name='mcNumber'
              placeholder='Enter MC Number'
              value={mcNumber}
              onChange={handleChangeVehicle}
              error={errors?.mcNumber || false}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.mcNumber && classes.is__error__border,
              )}
            />
          </div>
          <div className={classes.flex__field}>
            <Typography className={classes.label}>Unit Number</Typography>
            <TextField
              type='text'
              name='unitNumber'
              placeholder='Enter Unit Number'
              onChange={handleChangeVehicle}
              value={unitNumber}
              error={errors?.unitNumber || false}
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(
                classes.data__field,
                errors?.unitNumber && classes.is__error__border,
              )}
            />
          </div>
        </div>
      </div>
      {/* Actions */}
      <Buttons
        onCancel={() => {
          setToggle(false);
          clearVehicleInfoOnHeader();
        }}
        getVehicleObj={vehicleDetails}
        disabled={!vehicleMake || !vehicleModel || !modelYear || !licensePlate}
      />
    </div>
  );
}
